import classNames from 'classnames'

import { Modal } from '@/shared'

import style from './RemoveModal.module.scss'

interface IProps {
    entity?: string
    headerTitle: string
    onClose: () => void
    onRemoveCallback: () => void
}

export const RemoveModal = (props: IProps) => {
    const { entity, headerTitle, onClose, onRemoveCallback } = props

    const actions = [
        {
            title: 'ДА',
            callback: onRemoveCallback,
            className: style.accept
        },
        {
            title: 'НЕТ',
            callback: onClose,
            className: style.reject
        }
    ]

    return (
        <Modal show onClose={onClose}>
            <div className={style.container}>
                <div className={style.blockHeader}>
                    <span>{headerTitle}</span>
                </div>
                {entity && (
                    <div className={style.companyName}>
                        <span>{entity}</span>
                    </div>
                )}
                <div className={style.actionsWrapper}>
                    {actions.map((el) => {
                        const { title, callback, className } = el
                        return (
                            <button key={title} className={classNames(style.btn, className)} onClick={callback}>
                                {title}
                            </button>
                        )
                    })}
                </div>
            </div>
        </Modal>
    )
}
